var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tickets.length
    ? _c(
        "action-card",
        {
          attrs: {
            title: _vm.$t("nav.requests"),
            icon: "ticket",
            count: _vm.tickets.length
          },
          on: {
            open: function($event) {
              return _vm.$router.push("/requests")
            }
          }
        },
        _vm._l(_vm.visibleTickets, function(ticket) {
          return _c(
            "button",
            {
              key: ticket.id,
              staticClass: "portal-action-row",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$router.push("/requests/" + ticket.id)
                }
              }
            },
            [
              _c("span", { staticClass: "action-row-copy" }, [
                _c("strong", [_vm._v(_vm._s(ticket.subject))]),
                _c(
                  "small",
                  [
                    _vm._v("#" + _vm._s(ticket.ticketNumber)),
                    ticket.status
                      ? [
                          _vm._v(" · "),
                          _c("span", {
                            staticClass: "ticket-status-dot",
                            style: {
                              background:
                                _vm.ticketStatusHex(ticket, _vm.ticketTypes) ||
                                "var(--v-accent-base)"
                            }
                          }),
                          _vm._v(_vm._s(ticket.status))
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]),
              _c("portal-icon", { attrs: { name: "chevron-right", size: 18 } })
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }